// Incidents of a live event (livescore periods, statistics and the current
// one), shared by the timeline and the lineups.

export const typeOf = inc => parseInt(inc.IncidentType || inc.incidentType);
export const secondsOf = inc => {
  const s = parseInt(inc.Seconds || inc.seconds);
  if (!isNaN(s)) return s;
  const m = parseInt(inc.Time || inc.time);
  return isNaN(m) ? 0 : m * 60;
};
export const sideOf = inc => String(inc.ParticipantPosition || inc.participantPosition || '');
export const incidentKey = inc => inc.Id || inc.id || inc.uniqueId || `${typeOf(inc) || 0}-${secondsOf(inc)}-${sideOf(inc)}-${inc.PlayerId || inc.playerId || '0'}`;

export const YELLOW_CARD = 6;
export const RED_CARD = 7;
export const SUBSTITUTION = 10;

// Next to a player in the lineups: came on (green, up) / went off (red, down).
export const SUB_SVGS = {
  in: '<svg viewBox="0 0 24 24"><path d="M12 20V5M6 11l6-6 6 6" fill="none" stroke="#22c55e" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg>',
  out: '<svg viewBox="0 0 24 24"><path d="M12 4v15M6 13l6 6 6-6" fill="none" stroke="#ef4444" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg>'
};

export const CARD_SVGS = {
  yellow: '<svg viewBox="0 0 24 24"><rect x="6.5" y="3" width="11" height="16" rx="2" transform="rotate(10 12 11)" fill="#facc15"/><path d="M8.6 5.4l3.5.6-2.4 10.4" fill="none" stroke="#fff" stroke-opacity=".45" stroke-width="1.2" stroke-linecap="round"/></svg>',
  red: '<svg viewBox="0 0 24 24"><rect x="6.5" y="3" width="11" height="16" rx="2" transform="rotate(10 12 11)" fill="#ef4444"/><path d="M8.6 5.4l3.5.6-2.4 10.4" fill="none" stroke="#fff" stroke-opacity=".4" stroke-width="1.2" stroke-linecap="round"/></svg>'
};

// Goal icon: the football sport icon from the CDN.
export const GOAL_ICON = process.env.VUE_APP_URL_CLOUDFRONT + '/svg/sports/icons-color/6046.svg';

// Every incident once, newest first; `extra` are ones seen go by live.
export const collectIncidents = (ls, extra = []) => {
  if (!ls) return [];
  const list = [...extra];
  const rootInc = ls.CurrentIncident || ls.currentIncident;
  if (rootInc && parseInt(rootInc.IncidentType || rootInc.incidentType || 0) !== 0) list.push(rootInc);
  (ls.Periods || ls.periods || []).forEach(p => { (p.Incidents || p.incidents || []).forEach(i => list.push(i)); });
  (ls.Statistics || ls.statistics || []).forEach(s => { (s.Incidents || s.incidents || []).forEach(i => list.push(i)); });
  const unique = [];
  const seen = new Set();
  list.forEach(i => {
    const id = incidentKey(i);
    if (!seen.has(id)) {
      seen.add(id);
      i.calculatedSeconds = secondsOf(i);
      unique.push(i);
    }
  });
  return unique.sort((a, b) => b.calculatedSeconds - a.calculatedSeconds);
};

// Id and name of the player an incident is about (the one coming on, for a substitution).
export const incidentPlayer = inc => {
  const item = (inc.Players || inc.players)?.Item1?.[0];
  return {
    id: String(inc.PlayerId || inc.playerId || item?.Id || item?.id || ''),
    name: inc.PlayerName || inc.playerName || item?.Name || item?.name || ''
  };
};
